// @flow
export const SPLASH_DESC =
  'Splash posts lets you share your career milestones with your followers and connections. You only get 4 per month, so use them wisely!'

export const BOOST_DESC =
  'Boosts ensure that your post is seen by all publishers. You only get one per month.'
